import React from 'react';
import Menu from '../components/Menu';
import MapImage from '../images/fureso_plads_1.png';
import MapImage2 from '../images/fureso_plads_2.png';
import './StaticMap.css';

export const StaticMap = props => {
    return(
        <div className="App">
            <Menu/>
            <div className='static-map'>
                <img src={MapImage} alt=""/>
                <img src={MapImage2} alt=""/>
            </div>
        </div>
    )
};